import React from 'react'
import "./TermsCondition.css";
import { useSeo, SEO } from "../../config/seo";
export default function TermsCondition() {
  useSeo(SEO.terms);
  
  return (
    <div>
      
      
      <div class="container main-body-content ">
    <div class="row content">
        <div class="col-12 heading-termCondition">
            <h1 class="terms-heading">Terms and Conditions</h1>
            <h6>Last Updated: 03-01-2024</h6>
            <br/>
            <h3 class="section-title">1. Introduction</h3>
            <p>Welcome to CafeVist@ Pvt Ltd! These Terms and Conditions outline the rules and regulations for the use of
                <strong>CafeVist@ Pvt Ltd</strong>'s Website, located at https://cafevistaai.com/.
                By accessing this website, we assume you accept these terms and conditions. Do not continue to use Cafevist@AI or related to CafeVist@ Pvt Ltd if you do not agree to all of the terms and conditions stated on this page.</p>

                <h3 class="section-title">2. Intellectual Property Rights</h3>
            <p>Other than the content you own, under these Terms, <strong>CafeVist@ Pvt Ltd</strong> and/or its licensors own all the
                intellectual property rights and materials contained in this Website. You are granted limited license only for purposes of viewing the material contained on this Website.</p>

                <h3 class="section-title">3. Restrictions</h3>
            <p>You are specifically restricted from all of the following:

            </p><ul><li>Republishing, publishing, creating derivative works ofWebsite material in any other media.</li>
            <li>selling, sublicensing and/or otherwise commercializing any Website material</li>Selling, sublicensing, and/or otherwise commercializing any Website material.
            <li>Using this Website in any way that is or may be damaging to this Website</li>
            <li>Publicly performing and/or showing any Website material.</li>
            <li>Using this Website in any way that impacts user access to this Website.</li>
            <li>Using this Website contrary to applicable laws and regulations, or in any way may cause harm to the Website,
            or to any person or business entity.</li></ul><p></p>

            <h3 class="section-title">4. User Content</h3>
            <p>In these Website Standard Terms and Conditions, “User Content” shall mean any audio, video, text, images, or
            other material you choose to display on this Website. By displaying Your Content, you grant <strong>CafeVist@ Pvt Ltd</strong> a non-exclusive, worldwide irrevocable, sub-licensable license to use, reproduce, adapt, publish,
            translate and distribute it in any and all media.</p>

            <p>Your Content must be your own and must not be invading any third-party's rights. <strong>CafeVist@ Pvt Ltd</strong>
            reserves the right to remove any of Your Content from this Website at any time without notice.</p>

            <h3 class="section-title">5. No warranties</h3>
            <p>This Website is provided “as is,” with all faults, and <strong>CafeVist@ Pvt Ltd</strong> expresses no representations or
            warranties of any kind related to this Website or the materials contained on this Website.</p>

            <h3 class="section-title">6. Limitation of liability</h3>
            <p>In no event shall <strong>CafeVist@ Pvt Ltd</strong>, nor any of its officers, directors, and employees, be liable to you
            for anything arising out of or in any way connected with your use of this Website, whether such liability is
            under contract, tort, or otherwise.</p>

            <h3 class="section-title">7. Indemnification</h3>
            <p>You hereby indemnify to the fullest extent <strong>CafeVist@ Pvt Ltd</strong> from and against any and/or all liabilities,
            costs, demands, causes of action, damages, and expenses arising in any way related to your breach of any of
            the provisions of these Terms.</p>

            <h3 class="section-title">8. Severability</h3>
            <p>If any provision of these Terms is found to be invalid under any applicable law, such provisions shall be
            deleted without affecting the remaining provisions herein.</p>

            <h3 class="section-title">9. Variation of Terms</h3>
            <p><strong>CafeVist@ Pvt Ltd</strong> is permitted to revise these Terms at any time as it sees fit, and by using this Website
            you are expected to review these Terms on a regular basis.</p>

            <h3 class="section-title">10. Assignment</h3>
            <p>The <strong>CafeVist@ Pvt Ltd</strong> is allowed to assign, transfer, and subcontract its rights and/or obligations under
            these Terms without any notification. However, you are not allowed to assign, transfer, or subcontract any
            of your rights and/or obligations under these Terms.</p>

            <h3 class="section-title">11. Entire Agreement</h3>
            <p>These Terms constitute the entire agreement between <strong>CafeVist@ Pvt Ltd</strong> and you in relation to your use of
            this Website, and supersede all prior agreements and understandings.</p>

            <h3 class="section-title">12. Governing Law &amp; Jurisdiction</h3>
            <p>These Terms will be governed by and interpreted in accordance with the laws of the State/Country of Pakistan, and you submit to the non-exclusive jurisdiction of the state and federal courts located in
            Pakistan for the resolution of any disputes.</p>


        </div>
    </div>
</div>
      
    </div>
  )
}
